module.exports = (parcelRequire.load("dpqYs")).then(() => parcelRequire('C75PD'));